import { cn } from "@/lib/utils";

/** Spinning conic ribbon — used in place of generic loaders. */
export function RibbonSpinner({ size = 28, className }: { size?: number; className?: string }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn("relative inline-block", className)}
      style={{ width: size, height: size }}
    >
      <span
        className="absolute inset-0 rounded-full animate-spin-slow bg-ribbon-conic"
        style={{ maskImage: "radial-gradient(closest-side, transparent 58%, #000 60%)", WebkitMaskImage: "radial-gradient(closest-side, transparent 58%, #000 60%)" }}
      />
    </span>
  );
}

export default RibbonSpinner;